module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "instagram_small.8d4617c0.svg";